import script from "./TabImagesDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabImagesDownload.vue?vue&type=script&setup=true&lang=ts"

import "./TabImagesDownload.vue?vue&type=style&index=0&id=7ee7cd78&scoped=true&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ee7cd78"]])

export default __exports__